import { folder, id } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUploadDocumentRequestFailure(folder) {
      const result = getState().find(
        (result) => result.folder.uuid === folder.uuid,
      );

      return result ? result.request.isFailure : false;
    },
    isUploadDocumentRequestPending(folder) {
      const result = getState().find(
        (result) => result.folder.uuid === folder.uuid,
      );

      return result ? result.request.isPending : false;
    },
    isUploadDocumentRequestSuccess(folder) {
      const result = getState().find(
        (result) => result.folder.uuid === folder.uuid,
      );

      return result ? result.request.isSuccessful : false;
    },
  };
}

export { createSelector };
